// import master       from '../../assets/js/Master.js';
// import rcp          from '../../assets/js/Vertical/RCP.js';

// import polls        from '../../assets/section/polls.js';

import InitCovid    from '../../../assets/js/Covid/InitCovidApp.js';
InitCovid();

// import MastheadFull     from '../../assets/js/Sections/Masthead/MastheadFull.js';
// import MastheadShort    from '../../assets/js/Sections/Masthead/MastheadShort.js';
// import MastheadSites    from '../../assets/js/Sections/Masthead/MastheadSites.js';
// import StaffMenu        from '../../assets/js/Sections/Masthead/StaffMenu.js';

// import rc_newsletters   from '../../assets/top/rc-newsletters-v2.js';

// import RcmgAuth         from '../../assets/js/RCMG_V2/RcmgAuth.js';
// import RcmgModal        from '../../assets/js/RCMG_V2/RcmgModal.js';
// import RcmgSpot         from '../../assets/js/RCMG_V2/RcmgSpot.js';

// import lazysizes_rc_images from '../../assets/3rd_party/lazysizes/4.1.6/lazysizes_rc_images.js';